/**
 * Werehouses
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getWarehousesAction,
  updateWarehouseActions,
  createWarehousesActions,
  updateWarehousesStatusActions,
} from './actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectList,
  makeSelectLoading,
  makeSelectCountList,
} from './selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';
import Edit from './components/edit';
import Add from './components/add';
// import Inventory from './components/inventory';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import Modal from '../../components/Modal';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  Grid,
  DialogTitle,
  IconButton,
  MenuItem,
  Select,
  FormControl,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiWarehouse,
  mdiCheck,
  mdiPencilOutline,
  mdiStateMachine,
  mdiClose,
  mdiPlus,
  mdiKeyOutline,
  mdiHomeCityOutline,
} from '@mdi/js';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import { Props, SelectorProps, PayloadUpdate, PayloadCreate } from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import useQuery from '../../utils/hook/useQuery';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      padding: '10px 0',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const Warehouse: FunctionComponent<Props> = (props: Props) => {
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [filters, setFilters] = useState([] as Filter[]);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);

  const [openAdd, setopenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const filterTranslator = (fieldName: string) => {
    const status = {
      name: 'نام انبار',
      'name.equals': 'نام انبار:',
      'name.contains': 'نام انبار:',
      province: 'استان',
      'province.equals': 'استان',
      'province.contains': 'استان',
      'id.equals': 'شناسه انبار:',
      'id.contains': 'شناسه انبار:',
      city: 'شهر',
      'city.equals': 'شهر:',
      'city.contains': 'شهر:',
      capacity: 'ظرفیت',
      'capacity.equals': 'ظرفیت:',
      'capacity.contains': 'ظرفیت:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };
  useEffect(() => {
    getWarehouses();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getWarehouses = () => {
    const { page, size } = filtersValues;
    props.warehousesDispatch({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenDialog(false);
    setopenAdd(false);
    setOpenConfirmActive(false);
    setOpenSize(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام انبار',
        icon: mdiWarehouse,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه انبار',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'province.contains',
        label: 'استان ',
        icon: mdiHomeCityOutline,
      },
      {
        type: 'input',
        id: 'city.contains',
        label: 'شهر ',
        icon: mdiHomeCityOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: ' وضعیت انبار',
        data: ['ACTIVE', 'SUSPENDED'],
        translateType: 'center',
        icon: mdiStateMachine,
      },
    ]);
  };
  const headCells = [
    {
      id: 'id',
      label: 'شناسه انبار',
      type: 'input',
    },
    {
      id: 'name',
      label: 'نام انبار',
      type: 'input',
    },
    {
      id: 'province',
      label: 'استان',
      type: 'input',
    },
    {
      id: 'city',
      label: 'شهر',
      type: 'input',
    },

    {
      id: 'capacity',
      label: 'ظرفیت',
      type: 'input',
    },
  ];
  const head = { headCells };
  const handleDisableUser = async () => {
    await props.updateWarehouseStatusDispatch({
      id,
      body: 'SUSPENDED'.replace(/'/g, '"'),
      pagination: filtersValues,
    });
    setOpenConfirmDisable(false);
  };

  const handleActiveUser = async () => {
    await props.updateWarehouseStatusDispatch({
      id,
      body: 'ACTIVE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmActive(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);
    setId(id);
  };
  const handleOpenConfirmActive = (id: number) => {
    setOpenConfirmActive(true);
    setId(id);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h4" component="h2">
            {`لیست انبارها

            `}
          </Typography>
        </Grid>

        <Grid item sm={6} xs={12}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'name.contains',
              placeholder: 'نام انبار',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid xs={6} item container alignItems="center">
          {props.loading ? (
            ''
          ) : (
            <>
              <div className={classes.subtitle}>{`تعداد کل انبار:`}</div>
              <div>
                &nbsp;
                <b>{`${props.count}`}</b>
              </div>
            </>
          )}
        </Grid>

        <Grid container item xs={6} direction="row-reverse">
          <Button
            variant="contained"
            color="secondary"
            size="large"
            startIcon={<Icon path={mdiPlus} size={1} />}
            onClick={() => {
              setopenAdd(true);
            }}
          >{`ایجاد انبار جدید`}</Button>
        </Grid>

        <Grid container item spacing={6}>
          <Grid item xs={12}>
            {props.loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              <List
                data={props.warehousesList}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                handleOpenConfirmActive={handleOpenConfirmActive}
                handleOpen={handleOpen}
                changeStatus={handleOpenConfirmUpdateState}
                head={head}
                filterVal={filtersValues}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            {props.warehousesList.length > 0 && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleClose}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {props.warehousesList.length > 0 && (
              <Pagination
                className={classes.pagination}
                count={Math.ceil(props.count / filtersValues.size)}
                color="secondary"
                page={filtersValues.page + 1}
                onChange={handleChangePage}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      {/* <Dialog
        fullWidth
        open={openConfirmDisable}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          {` آیا از غیر فعال کردن انبار با نام
          "${props.warehousesList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
        </DialogTitle>
        <DialogActions>
          <Button
            autoFocus
            onClick={handleClose}
            variant="contained"
            color="primary"
          >
            {`خیر`}
          </Button>
          <Button
            onClick={handleDisableUser}
            variant="outlined"
            color="primary"
          >
            {`بله`}
          </Button>
        </DialogActions>
      </Dialog> */}
      {/* <Dialog
        fullScreen
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div>{`
      گزارش موجودی انبار
        "${props.warehousesList.find(item => item.id === id)?.name}"
        `}</div>
          <Button aria-label="details" size="medium" onClick={handleClose}>
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </DialogTitle>
        <DialogContent>
          {type === 'edit' && (
            <Edit
              data={props.warehousesList.find(item => item.id === id)}
              partnerId={props.match.params.id}
              update={body => {
                props.updateWarehouseDispatch({
                  body,
                  pagination: filtersValues,
                  id: props.match.params.id,
                });
                handleClose();
              }}
            />
          )}

          {type === 'inventory' && (
            <Inventory
              data={props.warehousesList.find(item => item.id === id)}
            />
          )}
        </DialogContent>
      </Dialog> */}

      {/* EDIT MODAL */}
      <Modal
        maxWidth="lg"
        onClose={handleClose}
        open={openDialog}
        title={
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
        }
        content={
          <>
            {type === 'edit' && (
              <Edit
                data={props.warehousesList.find(item => item.id === id)}
                partnerId={props.match.params.id}
                update={body => {
                  props.updateWarehouseDispatch({
                    body,
                    pagination: filtersValues,
                    id: props.match.params.id,
                  });
                  handleClose();
                }}
              />
            )}
          </>
        }
      />

      {/* ADD MODAL */}
      <Modal
        maxWidth="lg"
        onClose={handleClose}
        open={openAdd}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiWarehouse}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Add
            partnerId={props.match.params.id}
            create={body => {
              props.createWarehouseDispatch({
                body,
                pagination: filtersValues,
                id: props.match.params.id,
              });
              handleClose();
            }}
            onClose={handleClose}
          />
        }
      />

      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از

            ${openConfirmDisable ? 'غیر' : ''}
            فعال کردن انبار با نام
          "${props.warehousesList.find(item => item.id === id)?.name}"
          اطمینان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  warehousesList: makeSelectList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    warehousesDispatch: (payload: Object) =>
      dispatch(getWarehousesAction(payload)),
    updateWarehouseDispatch: (payload: PayloadUpdate) =>
      dispatch(updateWarehouseActions(payload)),
    createWarehouseDispatch: (payload: PayloadCreate) =>
      dispatch(createWarehousesActions(payload)),
    updateWarehouseStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateWarehousesStatusActions(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Warehouse);
